import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'black-teach-how-it-works-section',
  templateUrl: './teach-how-it-works-section.component.html',
  styleUrls: ['./teach-how-it-works-section.component.css'],
  standalone: true,
  imports: [CommonModule],
})
export class TeachHowItWorksSectionComponent {}
